function ident(value) {
    return value;
}

export {ident};
